webpackJsonp([16],{

/***/ 1108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawsDashboard_vue__ = __webpack_require__(1258);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20cdc251_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawsDashboard_vue__ = __webpack_require__(1380);
function injectStyle (ssrContext) {
  __webpack_require__(1377)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20cdc251"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawsDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20cdc251_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawsDashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormAlert',
  props: {
    message: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'warning'
    },
    // For alerts that are created already holding their message (rendered with v-if), where the
    // `message` watcher never fires: scroll to it once when it mounts.
    scrollOnMount: {
      type: Boolean,
      default: false
    },
    // No outer padding — for alerts positioned by the caller (e.g. overlaid on a table row)
    flush: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dismissed: false
    };
  },
  mounted: function mounted() {
    if (this.scrollOnMount && this.message) this.scrollToAlert();
  },
  watch: {
    message: function message(val) {
      this.dismissed = false;
      if (val) this.scrollToAlert();
    }
  },
  methods: {
    // Click on the message closes it. Hidden locally, and `dismiss` lets a caller that keeps the
    // message in its own state clear it too (so the same text can be shown again next time).
    dismiss: function dismiss() {
      this.dismissed = true;
      this.$emit('dismiss');
    },
    scrollToAlert: function scrollToAlert() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.$el) {
          _this.$el.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
    }
  }
});

/***/ }),

/***/ 1127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAlert_vue__ = __webpack_require__(1126);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcd5d34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAlert_vue__ = __webpack_require__(1131);
function injectStyle (ssrContext) {
  __webpack_require__(1129)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fcd5d34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcd5d34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1129:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1130);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("416c99d6", content, true, {});

/***/ }),

/***/ 1130:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".form-alert[data-v-3fcd5d34]{padding:.75rem 0}.form-alert--flush[data-v-3fcd5d34]{padding:0}.form-alert__body[data-v-3fcd5d34]{cursor:pointer;white-space:pre-line;text-align:left}.fade-enter-active[data-v-3fcd5d34]{transition:opacity .3s}.fade-leave-active[data-v-3fcd5d34]{transition:opacity .15s}.fade-enter[data-v-3fcd5d34],.fade-leave-to[data-v-3fcd5d34]{opacity:0}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/FormAlert.vue"],"names":[],"mappings":"AACA,6BACE,gBAAmB,CACpB,AACD,oCACE,SAAW,CACZ,AACD,mCACE,eAAgB,AAMhB,qBAAsB,AACtB,eAAiB,CANlB,AAQD,oCACE,sBAAyB,CAC1B,AACD,oCACE,uBAA0B,CAC3B,AACD,6DAEE,SAAW,CACZ","file":"FormAlert.vue","sourcesContent":["\n.form-alert[data-v-3fcd5d34] {\n  padding: 0.75rem 0;\n}\n.form-alert--flush[data-v-3fcd5d34] {\n  padding: 0;\n}\n.form-alert__body[data-v-3fcd5d34] {\n  cursor: pointer;\n}\n\n/* Keep newlines from multi-line messages (e.g. a list of blocked competitors)\n   so they render one per line instead of a run-on sentence. */\n.form-alert__body[data-v-3fcd5d34] {\n  white-space: pre-line;\n  text-align: left;\n}\n.fade-enter-active[data-v-3fcd5d34] {\n  transition: opacity 0.3s;\n}\n.fade-leave-active[data-v-3fcd5d34] {\n  transition: opacity 0.15s;\n}\n.fade-enter[data-v-3fcd5d34],\n.fade-leave-to[data-v-3fcd5d34] {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.message && !_vm.dismissed)?_c('div',{staticClass:"form-alert",class:{ 'form-alert--flush': _vm.flush },attrs:{"role":"alert"}},[_c('div',{staticClass:"form-alert__body alert-pop",class:("alert alert-" + _vm.type + " mb-0"),attrs:{"title":"Click to dismiss"},on:{"click":_vm.dismiss}},[_vm._v(_vm._s(_vm.message))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getYears;
function getYears() {
  var currentYear = new Date().getFullYear();
  return Array.from({
    length: 6
  }, function (_, i) {
    return currentYear - i;
  });
}

/***/ }),

/***/ 1168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildEventGroups;
/* harmony export (immutable) */ __webpack_exports__["c"] = flattenEventGroups;
/* harmony export (immutable) */ __webpack_exports__["b"] = buildLeafEventGroups;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * Groups a draft's flat, ordered event list for the Events table so that related events can
 * only be moved together:
 *   - a combined parent and its children form one unit (children only reorder inside it);
 *   - units tied by brother_id form one group (regular split A+B, combined split A+B, and a
 *     conjunction pair with its final) and are moved as a whole.
 * Units inside a group keep a fixed order (by id: the original/A row is always the lowest id).
 *
 * @param {Array} events flat list, already in display order
 * @returns {Array<{ id: number, units: Array<{ row: Object, children: Object[] }> }>}
 */
function buildEventGroups(events) {
  var position = new Map(events.map(function (event, index) {
    return [event.id, index];
  }));
  var ids = new Set(events.map(function (event) {
    return event.id;
  }));
  var childrenByParent = new Map();
  var roots = [];
  events.forEach(function (event) {
    if (event.parent_id != null && ids.has(event.parent_id)) {
      if (!childrenByParent.has(event.parent_id)) childrenByParent.set(event.parent_id, []);
      childrenByParent.get(event.parent_id).push(event);
    } else {
      roots.push(event);
    }
  });
  var rootById = new Map(roots.map(function (root) {
    return [root.id, root];
  }));
  var family = new Map(roots.map(function (root) {
    return [root.id, root.id];
  }));

  function find(id) {
    while (family.get(id) !== id) {
      id = family.get(id);
    }

    return id;
  }

  roots.forEach(function (root) {
    if (root.brother_id != null && rootById.has(root.brother_id)) {
      family.set(find(root.id), find(root.brother_id));
    }
  });
  var unitsByFamily = new Map();
  roots.forEach(function (root) {
    var key = find(root.id);
    if (!unitsByFamily.has(key)) unitsByFamily.set(key, []);
    unitsByFamily.get(key).push({
      row: root,
      children: childrenByParent.get(root.id) || []
    });
  });
  return _toConsumableArray(unitsByFamily.values()).map(function (units) {
    units.sort(function (a, b) {
      return a.row.id - b.row.id;
    });
    return {
      id: units[0].row.id,
      units: units,
      position: Math.min.apply(Math, _toConsumableArray(units.map(function (unit) {
        return position.get(unit.row.id);
      })))
    };
  }).sort(function (a, b) {
    return a.position - b.position;
  }).map(function (_ref) {
    var id = _ref.id,
        units = _ref.units;
    return {
      id: id,
      units: units
    };
  });
}
function flattenEventGroups(groups) {
  return groups.flatMap(function (group) {
    return group.units.flatMap(function (unit) {
      return [unit.row.id].concat(_toConsumableArray(unit.children.map(function (child) {
        return child.id;
      })));
    });
  });
}
/**
 * Same grouping for a list that has no parent rows (only leaf events): a unit is the set of
 * rows sharing a parent_id (or a lone event), and units are tied into one group through
 * brother_id (own, or the parent's `parent_brother_id`) — a regular split pair, a combined
 * split A+B, or a conjunction pair with its final.
 *
 * @param {Array} events flat list, already in display order
 * @returns {Array<{ id: number, rows: Object[] }>} rows are ordered unit by unit (lowest id first)
 */

function buildLeafEventGroups(events) {
  var unitKey = function unitKey(event) {
    return event.parent_id != null ? event.parent_id : event.id;
  };

  var brotherKey = function brotherKey(event) {
    return event.parent_id != null ? event.parent_brother_id : event.brother_id;
  };

  var family = new Map(events.map(function (event) {
    return [unitKey(event), unitKey(event)];
  }));

  function find(key) {
    while (family.get(key) !== key) {
      key = family.get(key);
    }

    return key;
  }

  events.forEach(function (event) {
    var brother = brotherKey(event);

    if (brother != null && family.has(brother)) {
      family.set(find(unitKey(event)), find(brother));
    }
  });
  var groups = new Map();
  events.forEach(function (event, index) {
    var key = find(unitKey(event));
    if (!groups.has(key)) groups.set(key, {
      rows: [],
      position: index
    });
    groups.get(key).rows.push({
      event: event,
      index: index
    });
  });
  return _toConsumableArray(groups.values()).sort(function (a, b) {
    return a.position - b.position;
  }).map(function (_ref2) {
    var rows = _ref2.rows;
    rows.sort(function (a, b) {
      return unitKey(a.event) - unitKey(b.event) || a.index - b.index;
    });
    return {
      id: rows[0].event.id,
      rows: rows.map(function (row) {
        return row.event;
      })
    };
  });
}

/***/ }),

/***/ 1180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EVENT_SPLIT_KIND_NONE */
/* unused harmony export EVENT_SPLIT_KIND_REGULAR_SPLIT */
/* unused harmony export EVENT_SPLIT_KIND_COMBINED_UNSPLIT_PARENT */
/* unused harmony export EVENT_SPLIT_KIND_COMBINED_UNSPLIT_CHILD */
/* unused harmony export EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_CONTAINER */
/* unused harmony export EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_CHILD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_FINAL; });
/* unused harmony export EVENT_SPLIT_KIND_COMBINED_SPLIT_SIDE_PARENT */
/* unused harmony export EVENT_SPLIT_KIND_COMBINED_SPLIT_SIDE_CHILD */
// Mirror of App\Enums\EventSplitKind (campdraftone-api) — `split_kind` field, e.g. on
// EventNominationsDashboardResource. Not backed by a single DB column (derived from
// parent_id/brother_id/is_conjunction/children_count, see Event::splitKind()). Keep in sync by
// hand; there is no shared source of truth across the two repos. No labels here — this enum has
// none on the backend either, it's an internal classification, not something shown verbatim.
var EVENT_SPLIT_KIND_NONE = 'none';
var EVENT_SPLIT_KIND_REGULAR_SPLIT = 'regular_split';
var EVENT_SPLIT_KIND_COMBINED_UNSPLIT_PARENT = 'combined_unsplit_parent';
var EVENT_SPLIT_KIND_COMBINED_UNSPLIT_CHILD = 'combined_unsplit_child';
var EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_CONTAINER = 'combined_conjunction_container';
var EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_CHILD = 'combined_conjunction_child';
var EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_FINAL = 'combined_conjunction_final';
var EVENT_SPLIT_KIND_COMBINED_SPLIT_SIDE_PARENT = 'combined_split_side_parent';
var EVENT_SPLIT_KIND_COMBINED_SPLIT_SIDE_CHILD = 'combined_split_side_child';

/***/ }),

/***/ 1220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DRAFT_STATE_OPEN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DRAFT_STATE_CLOSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DRAFT_STATE_FINALISE; });
/* unused harmony export DRAFT_STATE_ON_HOLD */
// Mirror of App\Enums\DraftState (campdraftone-api)
var DRAFT_STATE_OPEN = 1;
var DRAFT_STATE_CLOSED = 3;
var DRAFT_STATE_FINALISE = 5;
var DRAFT_STATE_ON_HOLD = 6;

/***/ }),

/***/ 1258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FormFields_FSearchSelect__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FormAlert__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__composables_draws_useDrawsDashboard__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__composables_useYears__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_date__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_draftStates__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_eventSplitKind__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_eventGroups__ = __webpack_require__(1168);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'DrawsDashboard',
  components: {
    TabLayout: __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */],
    PageHeading: __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_3__components_AppButton__["a" /* default */],
    FSearchSelect: __WEBPACK_IMPORTED_MODULE_4__components_FormFields_FSearchSelect__["a" /* default */],
    FormAlert: __WEBPACK_IMPORTED_MODULE_5__components_FormAlert__["a" /* default */]
  },
  setup: function setup() {
    var draftAlert = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({
      draftId: null,
      message: null,
      type: 'success'
    });
    var alertTimer = null;

    var setDraftAlert = function setDraftAlert(draftId, msg, type) {
      clearTimeout(alertTimer);
      draftAlert.value = {
        draftId: draftId,
        message: msg,
        type: type
      };
      alertTimer = setTimeout(function () {
        draftAlert.value = {
          draftId: null,
          message: null,
          type: 'success'
        };
      }, 5000);
    };

    var _useDrawsDashboard = Object(__WEBPACK_IMPORTED_MODULE_6__composables_draws_useDrawsDashboard__["a" /* default */])(),
        drafts = _useDrawsDashboard.drafts,
        loading = _useDrawsDashboard.loading,
        fetchDashboard = _useDrawsDashboard.fetchDashboard,
        publishAll = _useDrawsDashboard.publishAll,
        queueGenerateAll = _useDrawsDashboard.queueGenerateAll,
        queueGenerate = _useDrawsDashboard.queueGenerate;

    var years = Object(__WEBPACK_IMPORTED_MODULE_7__composables_useYears__["a" /* default */])();
    var year = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(new Date().getFullYear());

    function setYear(val) {
      year.value = val;
      fetchDashboard(val);
    }

    function onPublishAll(_x) {
      return _onPublishAll.apply(this, arguments);
    }

    function _onPublishAll() {
      _onPublishAll = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(draftId) {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                draftAlert.value = {
                  draftId: null,
                  message: null,
                  type: 'success'
                };
                _context.next = 3;
                return publishAll(draftId);

              case 3:
                result = _context.sent;
                if (result) setDraftAlert(draftId, result.message, result.type);
                _context.next = 7;
                return fetchDashboard(year.value);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _onPublishAll.apply(this, arguments);
    }

    function onGenerateAll(_x2) {
      return _onGenerateAll.apply(this, arguments);
    }

    function _onGenerateAll() {
      _onGenerateAll = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(draftId) {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                draftAlert.value = {
                  draftId: null,
                  message: null,
                  type: 'success'
                };
                _context2.next = 3;
                return queueGenerateAll(draftId);

              case 3:
                result = _context2.sent;
                if (result) setDraftAlert(draftId, result.message, result.type);
                _context2.next = 7;
                return fetchDashboard(year.value);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _onGenerateAll.apply(this, arguments);
    }

    function onGenerateEvent(_x3, _x4) {
      return _onGenerateEvent.apply(this, arguments);
    }

    function _onGenerateEvent() {
      _onGenerateEvent = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(eventId, draftId) {
        var result;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                draftAlert.value = {
                  draftId: null,
                  message: null,
                  type: 'success'
                };
                _context3.next = 3;
                return queueGenerate(eventId, draftId);

              case 3:
                result = _context3.sent;
                if (result) setDraftAlert(draftId, result.message, result.type);
                _context3.next = 7;
                return fetchDashboard(year.value);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _onGenerateEvent.apply(this, arguments);
    }

    function isSplitFinal(event) {
      return event.split_kind === __WEBPACK_IMPORTED_MODULE_10__constants_eventSplitKind__["a" /* EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_FINAL */];
    }

    function isEventVisible(event) {
      if (!event.requires_horse) return false;
      if (event.has_nominations) return true;
      if (isSplitFinal(event)) return true;
      return event.parent_draws_count > 0;
    } // Visible events laid out group by group (a split pair, a conjunction pair with its final,
    // combined A/B halves stay together). A heavier divider marks the start of every multi-event
    // group and the first row after one; single events get no extra divider.


    function eventRows(draft) {
      var rows = [];
      var previousWasMulti = false;
      Object(__WEBPACK_IMPORTED_MODULE_11__utils_eventGroups__["a" /* buildEventGroups */])(draft.events || []).forEach(function (group) {
        var visible = group.units.flatMap(function (unit) {
          return [unit.row].concat(_toConsumableArray(unit.children));
        }).filter(isEventVisible);
        var isMulti = visible.length > 1;
        visible.forEach(function (event, index) {
          rows.push({
            event: event,
            boundaryTop: index === 0 && (isMulti || previousWasMulti),
            boundaryBottom: false
          });
        });
        if (visible.length) previousWasMulti = isMulti;
      });
      if (rows.length && previousWasMulti) rows[rows.length - 1].boundaryBottom = true;
      return rows;
    }

    function eventDrawsCount(event) {
      if (event.draws_count > 0) return event.draws_count;
      if (event.parent_draws_count > 0) return event.parent_draws_count;
      return 0;
    }

    function eventLink(draftId, event) {
      if (!event.requires_horse) return null;
      return "/draws/".concat(draftId, "/").concat(event.id, "/1");
    }

    function canGenerateAll(draft) {
      if (draft.draft_state_id !== __WEBPACK_IMPORTED_MODULE_9__constants_draftStates__["a" /* DRAFT_STATE_CLOSED */]) return false;
      if (draft.is_generating) return false;
      var events = draft.events || [];
      return events.length > 0 && events.every(function (e) {
        return e.draws_count === 0;
      });
    }

    function canPublishAll(draft) {
      if (draft.auto_send_texts) return false;
      if (draft.events_not_published_count < 1) return false;
      if (draft.is_generating) return false;
      var events = draft.events || [];
      return events.some(function (e) {
        return e.draws_count > 0;
      });
    }

    function canGenerateEvent(draft, event) {
      if (!event.requires_horse) return false;
      if (draft.draft_state_id !== __WEBPACK_IMPORTED_MODULE_9__constants_draftStates__["a" /* DRAFT_STATE_CLOSED */]) return false;
      if (event.draws_count > 0) return false;
      if (event.parent_draws_count > 0) return false;
      if (isSplitFinal(event)) return false;
      return true;
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      fetchDashboard(year.value);
    });
    return {
      draftAlert: draftAlert,
      drafts: drafts,
      loading: loading,
      years: years,
      year: year,
      setYear: setYear,
      onPublishAll: onPublishAll,
      onGenerateAll: onGenerateAll,
      onGenerateEvent: onGenerateEvent,
      isEventVisible: isEventVisible,
      eventRows: eventRows,
      eventDrawsCount: eventDrawsCount,
      eventLink: eventLink,
      canGenerateAll: canGenerateAll,
      canPublishAll: canPublishAll,
      canGenerateEvent: canGenerateEvent,
      formatDateTime: __WEBPACK_IMPORTED_MODULE_8__utils_date__["b" /* formatDateTime */]
    };
  }
}));

/***/ }),

/***/ 1377:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1378);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("be2ed47e", content, true, {});

/***/ }),

/***/ 1378:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(1094);
exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".draws-dashboard__draft[data-v-20cdc251]{border:1px solid #dee2e6}.draws-dashboard__header[data-v-20cdc251]{display:flex;justify-content:space-between;align-items:center;gap:.5rem;background-color:#e9ecef;padding:.75rem 1rem;border-bottom:1px solid #dee2e6}.draws-dashboard__header-left[data-v-20cdc251]{flex:1}.draws-dashboard__header-actions[data-v-20cdc251]{display:flex;justify-content:center;gap:.5rem;flex:1}.draws-dashboard__header-right[data-v-20cdc251]{flex:1;display:flex;justify-content:flex-end;gap:.5rem}.draws-dashboard__draft-name[data-v-20cdc251]{font-size:1.25rem;font-weight:700}.draws-dashboard__draft-date[data-v-20cdc251]{font-size:.95rem;color:#6c757d}.draws-dashboard__events[data-v-20cdc251]{list-style:none;margin:0;padding:0}.draws-dashboard__event[data-v-20cdc251]{display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:.5rem;padding:.75rem 1rem;border-bottom:1px solid #dee2e6}.draws-dashboard__event[data-v-20cdc251]:last-child{border-bottom:none}.draws-dashboard__event.draws-dashboard__event--boundary[data-v-20cdc251]{border-top:2px solid var(--gray-400);margin-top:-1px}.draws-dashboard__event.draws-dashboard__event--boundary-end[data-v-20cdc251]{border-bottom:2px solid var(--gray-400)}.draws-dashboard__event-actions[data-v-20cdc251]{display:flex;flex-wrap:wrap;gap:.5rem}.draws-dashboard__warn-icon[data-v-20cdc251]{display:inline-block;background-image:url(" + escape(__webpack_require__(1095)) + ");background-position:-34px 0;width:32px;height:28px;vertical-align:middle;margin-right:.4rem}@media (max-width:600px){.draws-dashboard__header[data-v-20cdc251]{flex-direction:column;align-items:stretch}.draws-dashboard__header-actions[data-v-20cdc251],.draws-dashboard__header-right[data-v-20cdc251]{flex-direction:column;justify-content:flex-start}.draws-dashboard__header-actions .btn[data-v-20cdc251],.draws-dashboard__header-right .btn[data-v-20cdc251]{width:100%}.draws-dashboard__event[data-v-20cdc251]{flex-direction:column;align-items:stretch}.draws-dashboard__event-info[data-v-20cdc251]{text-align:left}.draws-dashboard__event-actions[data-v-20cdc251]{flex-direction:column;align-items:flex-start}.draws-dashboard__event-actions .btn[data-v-20cdc251]{width:100%;text-align:left}}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Draws/Dashboard/DrawsDashboard.vue"],"names":[],"mappings":"AACA,yCACE,wBAA0B,CAC3B,AACD,0CACE,aAAc,AACd,8BAA+B,AAC/B,mBAAoB,AACpB,UAAY,AACZ,yBAA0B,AAC1B,oBAAsB,AACtB,+BAAiC,CAClC,AACD,+CACE,MAAQ,CACT,AACD,kDACE,aAAc,AACd,uBAAwB,AACxB,UAAY,AACZ,MAAQ,CACT,AACD,gDACE,OAAQ,AACR,aAAc,AACd,yBAA0B,AAC1B,SAAY,CACb,AACD,8CACE,kBAAmB,AACnB,eAAiB,CAClB,AACD,8CACE,iBAAmB,AACnB,aAAe,CAChB,AACD,0CACE,gBAAiB,AACjB,SAAU,AACV,SAAW,CACZ,AACD,yCACE,aAAc,AACd,8BAA+B,AAC/B,mBAAoB,AACpB,eAAgB,AAChB,UAAY,AACZ,oBAAsB,AACtB,+BAAiC,CAClC,AACD,oDACE,kBAAoB,CACrB,AACD,0EACE,qCAAsC,AACtC,eAAiB,CAClB,AACD,8EACE,uCAAyC,CAC1C,AACD,iDACE,aAAc,AACd,eAAgB,AAChB,SAAY,CACb,AACD,6CACE,qBAAsB,AACtB,+CAAkD,AAClD,4BAA+B,AAC/B,WAAY,AACZ,YAAa,AACb,sBAAuB,AACvB,kBAAqB,CACtB,AACD,yBACA,0CACI,sBAAuB,AACvB,mBAAqB,CACxB,AACD,kGAEI,sBAAuB,AACvB,0BAA4B,CAC/B,AACD,4GAEI,UAAY,CACf,AACD,yCACI,sBAAuB,AACvB,mBAAqB,CACxB,AACD,8CACI,eAAiB,CACpB,AACD,iDACI,sBAAuB,AACvB,sBAAwB,CAC3B,AACD,sDACI,WAAY,AACZ,eAAiB,CACpB,CACA","file":"DrawsDashboard.vue","sourcesContent":["\n.draws-dashboard__draft[data-v-20cdc251] {\n  border: 1px solid #dee2e6;\n}\n.draws-dashboard__header[data-v-20cdc251] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.5rem;\n  background-color: #e9ecef;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #dee2e6;\n}\n.draws-dashboard__header-left[data-v-20cdc251] {\n  flex: 1;\n}\n.draws-dashboard__header-actions[data-v-20cdc251] {\n  display: flex;\n  justify-content: center;\n  gap: 0.5rem;\n  flex: 1;\n}\n.draws-dashboard__header-right[data-v-20cdc251] {\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n}\n.draws-dashboard__draft-name[data-v-20cdc251] {\n  font-size: 1.25rem;\n  font-weight: 700;\n}\n.draws-dashboard__draft-date[data-v-20cdc251] {\n  font-size: 0.95rem;\n  color: #6c757d;\n}\n.draws-dashboard__events[data-v-20cdc251] {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.draws-dashboard__event[data-v-20cdc251] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #dee2e6;\n}\n.draws-dashboard__event[data-v-20cdc251]:last-child {\n  border-bottom: none;\n}\n.draws-dashboard__event.draws-dashboard__event--boundary[data-v-20cdc251] {\n  border-top: 2px solid var(--gray-400);\n  margin-top: -1px;\n}\n.draws-dashboard__event.draws-dashboard__event--boundary-end[data-v-20cdc251] {\n  border-bottom: 2px solid var(--gray-400);\n}\n.draws-dashboard__event-actions[data-v-20cdc251] {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n.draws-dashboard__warn-icon[data-v-20cdc251] {\n  display: inline-block;\n  background-image: url('~@/assets/img/sprite.png');\n  background-position: -34px 0px;\n  width: 32px;\n  height: 28px;\n  vertical-align: middle;\n  margin-right: 0.4rem;\n}\n@media (max-width: 600px) {\n.draws-dashboard__header[data-v-20cdc251] {\n    flex-direction: column;\n    align-items: stretch;\n}\n.draws-dashboard__header-actions[data-v-20cdc251],\n  .draws-dashboard__header-right[data-v-20cdc251] {\n    flex-direction: column;\n    justify-content: flex-start;\n}\n.draws-dashboard__header-actions .btn[data-v-20cdc251],\n  .draws-dashboard__header-right .btn[data-v-20cdc251] {\n    width: 100%;\n}\n.draws-dashboard__event[data-v-20cdc251] {\n    flex-direction: column;\n    align-items: stretch;\n}\n.draws-dashboard__event-info[data-v-20cdc251] {\n    text-align: left;\n}\n.draws-dashboard__event-actions[data-v-20cdc251] {\n    flex-direction: column;\n    align-items: flex-start;\n}\n.draws-dashboard__event-actions .btn[data-v-20cdc251] {\n    width: 100%;\n    text-align: left;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1379:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useDrawsDashboard;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_draws__ = __webpack_require__(439);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



function useDrawsDashboard() {
  var drafts = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

  function fetchDashboard(_x) {
    return _fetchDashboard.apply(this, arguments);
  }

  function _fetchDashboard() {
    _fetchDashboard = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(year) {
      var params, res, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              params = {};
              if (year != null) params.year = year;
              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].getDashboard(params);

            case 6:
              res = _context.sent;
              data = res.data.data;
              drafts.value = data.drafts != null ? data.drafts : [];
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              drafts.value = [];

            case 14:
              _context.prev = 14;
              loading.value = false;
              return _context.finish(14);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 11, 14, 17]]);
    }));
    return _fetchDashboard.apply(this, arguments);
  }

  function publishAll(_x2) {
    return _publishAll.apply(this, arguments);
  }

  function _publishAll() {
    _publishAll = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(draftId) {
      var res, msg;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].publishAll(draftId);

            case 3:
              res = _context2.sent;
              return _context2.abrupt("return", {
                message: res.data.message || 'All draws published.',
                type: 'success'
              });

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              msg = _context2.t0.response != null && _context2.t0.response.data != null ? _context2.t0.response.data.message : 'Failed to publish draws.';
              return _context2.abrupt("return", {
                message: msg,
                type: 'warning'
              });

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));
    return _publishAll.apply(this, arguments);
  }

  function queueGenerateAll(_x3) {
    return _queueGenerateAll.apply(this, arguments);
  }

  function _queueGenerateAll() {
    _queueGenerateAll = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(draftId) {
      var res, msg;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].queueGenerateAll(draftId);

            case 3:
              res = _context3.sent;
              return _context3.abrupt("return", {
                message: res.data.message || 'Draw generation queued.',
                type: 'success'
              });

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              msg = _context3.t0.response != null && _context3.t0.response.data != null ? _context3.t0.response.data.message : 'Failed to queue draw generation.';
              return _context3.abrupt("return", {
                message: msg,
                type: 'warning'
              });

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 7]]);
    }));
    return _queueGenerateAll.apply(this, arguments);
  }

  function queueGenerate(_x4, _x5) {
    return _queueGenerate.apply(this, arguments);
  }

  function _queueGenerate() {
    _queueGenerate = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4(eventId, draftId) {
      var res, msg;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].queueGenerate(eventId, {
                draft_id: draftId
              });

            case 3:
              res = _context4.sent;
              return _context4.abrupt("return", {
                message: res.data.message || 'Draw generation queued.',
                type: 'success'
              });

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);
              msg = _context4.t0.response != null && _context4.t0.response.data != null ? _context4.t0.response.data.message : 'Failed to queue draw generation.';
              return _context4.abrupt("return", {
                message: msg,
                type: 'warning'
              });

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 7]]);
    }));
    return _queueGenerate.apply(this, arguments);
  }

  return {
    drafts: drafts,
    loading: loading,
    fetchDashboard: fetchDashboard,
    publishAll: publishAll,
    queueGenerateAll: queueGenerateAll,
    queueGenerate: queueGenerate
  };
}

/***/ }),

/***/ 1380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"full-width":true}},[_c('div',{staticClass:"bg-white rounded mb-4 p-3",attrs:{"slot":"tabContent"},slot:"tabContent"},[_c('page-heading',[_vm._v("Draws Dashboard")]),_vm._v(" "),_c('div',{staticClass:"alert alert-info"},[_vm._v("\n      Draw Generation Checklist:\n      "),_c('ol',{staticClass:"mb-0 mt-1"},[_c('li',[_vm._v("Have you moved your draft to closed status? Draws will not generate unless the draft is in closed status.")]),_vm._v(" "),_c('li',[_vm._v("If you have split an event into A/B drafts ensure you have moved competitors between these two events where necessary before draw generation.")]),_vm._v(" "),_c('li',[_vm._v("Have you scratched all unpaid runs you do not wish to appear in the draw? If a competitor has not paid and you do not wish them to be in the draw please scratch them.")])])]),_vm._v(" "),_c('div',{staticClass:"alert alert-info"},[_vm._v("\n      For assistance during regular business hours (Monday-Friday 8:30am-4pm AEST) contact the ACA Office at 07 4622 3110.\n      For assistance after-hours for the duration of you draft only call the Campdraft One After-Hours line at 07 4622 7110.\n      This line is only attended for the duration of your draft and will not work before or after your draft has commenced.\n    ")]),_vm._v(" "),_c('div',{staticClass:"alert alert-warning text-center"},[_c('span',{staticClass:"draws-dashboard__warn-icon"}),_vm._v("\n      IF YOU DO NOT MARK YOUR EVENT MEMBERS AS PAID IN THE SEPARATE EVENT MEMBER AREA THEY WILL NOT SHOW IN THE DRAW.\n    ")]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"font-weight-bold"},[_vm._v("Filter by year")]),_vm._v(" "),_c('div',{staticStyle:{"max-width":"120px"}},[_c('f-search-select',{attrs:{"id":"draws_dashboard_year","value":_vm.year,"options":_vm.years.map(function (y) { return ({ id: y, name: String(y) }); }),"searchable":false},on:{"input":function($event){_vm.setYear(Number($event))}}})],1)]),_vm._v(" "),_vm._l((_vm.drafts),function(draft){return _c('div',{key:draft.id,staticClass:"mb-5"},[_c('form-alert',{attrs:{"message":_vm.draftAlert.draftId === draft.id ? _vm.draftAlert.message : null,"type":_vm.draftAlert.type}}),_vm._v(" "),(draft.event_members_allowed)?_c('div',{staticClass:"alert alert-warning mb-0 rounded-0"},[_vm._v("\n          Click "),_c('router-link',{staticClass:"text-primary",attrs:{"to":("/draft-members/" + (draft.id))}},[_vm._v("here")]),_vm._v(" to mark event members as paid.\n      ")],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"draws-dashboard__draft"},[_c('div',{staticClass:"draws-dashboard__header"},[_c('div',{staticClass:"draws-dashboard__header-left"},[_c('span',{staticClass:"draws-dashboard__draft-name"},[_vm._v(_vm._s(draft.name))]),_vm._v(" "),(draft.start_date)?_c('div',{staticClass:"draws-dashboard__draft-date"},[_vm._v(_vm._s(_vm.formatDateTime(draft.start_date)))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"draws-dashboard__header-actions"},[(_vm.canPublishAll(draft))?_c('app-button',{attrs:{"size":"sm","block":false,"disabled":draft.is_generating},on:{"click":function($event){return _vm.onPublishAll(draft.id)}}},[_vm._v("\n              Publish all draws\n            ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"draws-dashboard__header-right"},[(_vm.canGenerateAll(draft))?_c('app-button',{attrs:{"size":"sm","block":false,"disabled":draft.is_generating},on:{"click":function($event){return _vm.onGenerateAll(draft.id)}}},[_vm._v("\n              Generate all draws\n            ")]):_vm._e(),_vm._v(" "),(draft.has_calc_places)?_c('router-link',{staticClass:"btn btn-sm btn-primary text-nowrap",attrs:{"to":("/drafts/" + (draft.id) + "/prize-summary")}},[_vm._v("\n              PRIZE MONEY SUMMARY\n            ")]):_vm._e()],1)]),_vm._v(" "),(draft.events && draft.events.length)?_c('ul',{staticClass:"draws-dashboard__events"},[_vm._l((_vm.eventRows(draft)),function(ref){
var event = ref.event;
var boundaryTop = ref.boundaryTop;
var boundaryBottom = ref.boundaryBottom;
return [_c('li',{key:event.id,staticClass:"draws-dashboard__event",class:{ 'draws-dashboard__event--boundary': boundaryTop, 'draws-dashboard__event--boundary-end': boundaryBottom }},[_c('div',{staticClass:"draws-dashboard__event-info"},[(_vm.eventDrawsCount(event) > 0)?[_c('router-link',{attrs:{"to":_vm.eventLink(draft.id, event)}},[_vm._v("\n                    "+_vm._s(event.name)+" ("+_vm._s(_vm.eventDrawsCount(event))+")\n                  ")])]:_c('span',[_vm._v(_vm._s(event.name))])],2),_vm._v(" "),_c('div',{staticClass:"draws-dashboard__event-actions"},[(_vm.canGenerateEvent(draft, event))?_c('app-button',{attrs:{"variant":"outline-primary","size":"sm","disabled":draft.is_generating},on:{"click":function($event){return _vm.onGenerateEvent(event.id, draft.id)}}},[_vm._v("\n                  Generate event draws\n                ")]):_vm._e(),_vm._v(" "),(event.requires_horse && event.calculator_id && event.calculator_initialized)?_c('router-link',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"to":("/prizes/" + (event.id))}},[_vm._v("\n                  View results\n                ")]):_vm._e(),_vm._v(" "),(event.requires_horse && event.calculator_id)?_c('router-link',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"to":("/calculators/" + (event.id))}},[_vm._v("\n                  Edit calculations\n                ")]):_vm._e()],1)])]})],2):_vm._e()])],1)})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/16.bd8b63cb2189dc86dce4.js